import gql from 'graphql-tag';
import ImageDataFragment from './ImageData.gql';

export default gql`
  fragment SideBySideItemFragment on SideBySideItem {
    id
    type
    data {
      image {
        ...ImageDataFragment
      }
      html
    }
  }
  ${ImageDataFragment}
`;
